import { forwardRef } from 'react'

import { ProseInput } from 'common/ProseInput/ProseInput'

import { ContentComposerProps } from 'components/ShareSheet/Types'
import Styles from './ContentComposer.module.scss'
import { ProseInputHandle } from 'common/ProseInput/Types'
import cx from 'classnames'

const ContentComposer = forwardRef<ProseInputHandle, ContentComposerProps>(
  ({ content, onChange, placeholder = 'Type your message here...', size = 'sm' }, forwardedRef) => {
    return (
      <div className={Styles.wrapper}>
        <ProseInput
          className={cx(Styles.contentEditor, Styles[size])}
          initialHtmlString={content}
          onChange={onChange}
          placeholder={placeholder}
          ref={forwardedRef}
        />
      </div>
    )
  },
)

export { ContentComposer }
